import {AnswerValue} from './answer-value';

export class BooleanAnswerValue extends AnswerValue {
  equals(other: BooleanAnswerValue): boolean {
    return super.equals(other) && this.checked == other.checked;
  }
  isValid(): boolean {
    return super.isValid() &&
      this.checked != null && this.checked != undefined;
  }
  constructor( public label : string, public checked : boolean) {
    super(label);
  }
  copy() : AnswerValue {
    return new BooleanAnswerValue(this.label, this.checked);
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/boolean-answer-value.ts